import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ContentManagerComponent } from './content-manager/content-manager.component';
import { MediaBrowseComponent } from './media-browse/media-browse.component';
import { ImagesPageComponent } from './images-page/images-page.component';
import { VideosPageComponent } from './videos-page/videos-page.component';
import { MediaGridComponent } from './media-grid/media-grid.component';
import { ImageCardComponent } from './image-card/image-card.component';
import { VideoCardComponent } from './video-card/video-card.component';
import { MediaRoutingModule } from './media-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    ContentManagerComponent,
    MediaBrowseComponent,
    ImagesPageComponent,
    VideosPageComponent,
    MediaGridComponent,
    ImageCardComponent,
    VideoCardComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MediaRoutingModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTabsModule,
    MatDividerModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatIconModule
  ],
  exports: [
    ContentManagerComponent,
    MediaGridComponent,
    ImageCardComponent,
    VideoCardComponent
  ]
})
export class MediaModule {}
